import { ProductCategoryKeys } from '../common/enums/common';
import { TyRegionBasic } from '../types';
import { getKPRegion, getRegionForConfig, getRegionFromUri} from './regionUtils';
import { safeGet } from './objectUtils';

type range = 'negative' | 'positive';

export const getRxCompatibleRules = (config: any, region: TyRegionBasic, range: range) => {
  return safeGet(config, `${region?.toLowerCase()}.rules.incompatibleRxTable.${range}`, null);
};

export const getNewTagNumberOfDays = (
  config: any,
  productCategory = ProductCategoryKeys.EYEGLASS_FRAMES,
) => {
  return safeGet(config, `nat.rules.productCategories.${productCategory}.new.numberOfDays`, null);
};

export const isFavoriteEnabled = (config: any, productCategory: ProductCategoryKeys) => {
  return safeGet(config, `nat.rules.productCategories.${productCategory}.isFavoriteEnabled`, null);
};

export const getCommerceToolsCategoryId = (config: any, prodCategory: ProductCategoryKeys) => {
  return safeGet(config, `nat.commerceTools.categories.${prodCategory}.categoryId`, null);
};

export const getCommerceToolsPriceRange = (config: any, prodCategory: ProductCategoryKeys) => {
  return safeGet(config, `nat.rules.productCategories.eyeglass_frames.priceCheck.minSellPrice`, null);
};

export const getCommerceToolsMaxPriceRange = (config: any) => {
  return safeGet(config, `nat.rules.productCategories.eyeglass_frames.priceCheck.maxSellPrice`, null);
};

export const getSimilarProductsPriceRange = (config: any) => {
  return safeGet(config, `${getRegionForConfig()}.data.framesSimilarProductsPriceRange`, null);
};

export const getCommerceToolsChannelId = (config: any) => {
  return safeGet(config, `${getRegionForConfig()}.commerceTools.channels.id`, null);
};

export const getCommerceToolsHasProtectionPlans = (config: any) => {
  return safeGet(
    config,
    `${getRegionForConfig()}.rules.savingProtectionPlans.hasProtectionOnlyPlans`,
    null,
  );
};

export const getGoogleMapsConfig = (config: any) => {
  return safeGet(config, `services.google.maps`, null);
};


export const getStoreConfigsCode = (config: any, region: TyRegionBasic) => {
  const storeConfig = {
    geoCode: safeGet(config, `${region?.toLowerCase()}.data.storeLocator.defaultGeoCode`, null),
    mileOptions: safeGet(config, `${region?.toLowerCase()}.data.storeLocator.mileOptions`, null),
    defaultMapZoom: safeGet(
      config,
      `${region?.toLowerCase()}.data.storeLocator.defaultMapZoom`,
      null,
    ),
    defaultMapRadius: safeGet(
      config,
      `${region?.toLowerCase()}.data.storeLocator.defaultMapRadius`,
      null,
    ),
  };

  return storeConfig;
};

export const getCommerceToolsChannelLimit = (config: any, region: TyRegionBasic) => {
  return safeGet(config, `${region?.toLowerCase()}.commerceTools.limit`, null);
};

export const getCheckoutPaymentConfig = (config: any, region: TyRegionBasic) => {
  return safeGet(config, `${region?.toLowerCase()}.ewallet`, null);
};

export const getLogoutURL = (config: any) => {
  const region = getRegionFromUri();
  let url = safeGet(config, 'services.kpSSO.logoutUrl', `/logout`);
  return url.replace('$region', region?.toLowerCase());
};

export const getLoginURL = (config: any) => {
  const region = getRegionFromUri();
  let url = safeGet(config, 'services.kpSSO.loginUrl', `/login`);
  return url.replace('$region', region?.toLowerCase());
};
export const getRegionName = (region: any) => {
  return getRegionForConfig(region)
}
